// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"Table_tableContainer__ayn3d","table":"Table_table__mcSIi","ellipsis":"Table_ellipsis__bEURk"};